import * as React from 'react';

// Upload mark — mirrors the existing Download icon (Actions/Download.js)
// with the arrow chevron flipped so it points UP out of the tray instead
// of DOWN into it. Same stroke + tray geometry, so the two read as a
// matched pair when used side-by-side.
export default (props) => {
  const size = props.size || 24;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M24 0v24H0V0z" />
        <g
          stroke={props.color || '#B5BFD2'}
          strokeLinecap="round"
          strokeWidth="2"
          style={{ transition: props.withTransition ? 'stroke 0.3s ease' : 'none' }}
        >
          <path d="M12 5v8" />
          <path strokeLinejoin="round" d="M9 8l3-3 3 3" />
        </g>
        <path
          stroke={props.color || '#B5BFD2'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6 13l-2 5h16l-2-5"
          style={{ transition: props.withTransition ? 'stroke 0.3s ease' : 'none' }}
        />
      </g>
    </svg>
  );
};
